import React from 'react'

const LogoutIcon = props => {
    const height = props.height || 20
    const width = props.width || 20
    const color = props.color || '#202020'
    const strokeWidth = props.strokeWidth || '1'
    return (
      <svg width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g stroke="#202020" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9.333 4.667v-2c0-.737-.597-1.334-1.333-1.334H2.667c-.737 0-1.334.597-1.334 1.334v10.666c0 .737.597 1.334 1.334 1.334H8c.736 0 1.333-.597 1.333-1.334v-2M6.666 8h8M12 5.333 14.667 8 12 10.667" />
      </g>
    </svg>
  )
}
export default LogoutIcon
